import React from 'react';
import { Table } from 'antd';
import './styles/my-table.scss';

const MyTable = (props) => {
  return <Table className="my-table" {...props} />;
};

export default MyTable;
